import { module } from 'modujs';
import ScrollObserver from '../utils/scroll';
import { queryClosestParent } from '../utils/html';
import { html } from '../utils/environment'
import { lazyLoadImage } from '../utils/lazyload';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0)

        setTimeout(() => {
            this.initScrollInstance()
        }, 200);
    }

    initScrollInstance() {
        if (this.scrollObserver) return
        this.scrollObserver = new ScrollObserver({
            el: this.el,
            rootMargin: "-1px 0% -10% 0%", // relative to the viewport
            hasScrollEvent: true,
            scrollCallback: this.onScroll.bind(this)
        });

        this.scrollObserver.on('call', (func,way,obj,id) => {
            // Using modularJS
            this.call(func[0],{way,obj},func[1],func[2]);
        });

        this.onUpdate()
    }

    destroyScrollInstance() {
        this.raf && cancelAnimationFrame(this.raf);
        this.scrollObserver && this.scrollObserver.destroy()
        this.scrollObserver = null
    }

    resetScrollInstance() {
        this.destroyScrollInstance()
        requestAnimationFrame(() => {
            this.initScrollInstance()
        })
    }

    onUpdate() {
        this.raf = requestAnimationFrame(()=>this.onUpdate());
        if(html.scrollTop > 80 || document.body.scrollTop > 80) {
            html.classList.add('has-scrolled');
        } else {
            html.classList.remove('has-scrolled');
        }
    }

    onScroll(event) {
        const $stickyHeader = document.querySelector('.c-header.-sticky')
        if(this.scrollObserver.scrollDirection == 'down') {
            $stickyHeader.inert = true
            html.classList.add('is-scrolling-down')
        } else {
            $stickyHeader.inert = false
            html.classList.remove('is-scrolling-down')
        }
    }

    toggleLazy(args) {
        lazyLoadImage(args.obj.target, null, () => {
            //callback
        })
    }

    toggleBlob(args) {
        const moduleID = args.obj.target.dataset.moduleBlob

        if (args.way === "enter") {
            this.call('onPlay', null, 'Blob', moduleID)
        } else if (args.way === "exit") {
            this.call('onStop', null, 'Blob', moduleID)
        }
    }

    toggleSplitText(args) {
        const moduleID = args.obj.target.dataset.moduleSplitText
        if (args.way === "enter") {
            this.call('playAnime', null, 'SplitText', moduleID)
        }
    }

    toggleVideoPlaying(args) {
        const moduleID = args.obj.target.dataset.moduleVideo
        this.call('togglePlay', null, 'Video', moduleID)
    }

    scrollTo(args) {
        if (this.scrollObserver && this.scrollObserver.scrollTo) {
            this.scrollObserver.scrollTo(args[0], args[1])
        }
    }

    destroy() {
        super.destroy();
        this.destroyScrollInstance()
    }
}
